import { SvgLoading } from '@deltasierra/components';
import * as React from 'react';
import styled from 'styled-components';

const StyledThumbnailLoaderContainer = styled.span`
    position: absolute;
    top: 2px;
    right: 2px;
    font-size: 5px;
    opacity: 0.7;
`;

type PlannerItemThumbnailLoaderProps = {};

export function PlannerItemThumbnailLoader({}: PlannerItemThumbnailLoaderProps) {
    return (
        <StyledThumbnailLoaderContainer>
            <SvgLoading />
        </StyledThumbnailLoaderContainer>
    );
}
PlannerItemThumbnailLoader.displayName = 'PlannerItemThumbnailLoader';
